import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Container, Button, Badge, Tabs, Tab } from 'react-bootstrap';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { FaFilter } from "react-icons/fa";

import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const ConversionFilesHistory = () => {
  const [conversionFiles, setConversionFiles] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [hideTestConversions, setHideTestConversions] = useState(false);
  const [activeTab, setActiveTab] = useState('files');
  const [searchUsername, setSearchUsername] = useState('');

  const bankTypes = [
    'privatbank', 'pumb', 'mtb', 'universal', 
    'mono', 'ray', 'ukr', 'piv', 'oshchad', 'abank', 'otp', 'vos', 'kredo'
  ];

  useEffect(() => {
    fetchConversionFiles();
  }, []);

  const fetchConversionFiles = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/conversion-files-history');
      setConversionFiles(response.data);
    } catch (error) {
      console.error('Error fetching conversion files:', error);
    }
  };

  const handleDownload = async (filePath) => {
    try {
      const response = await axios.get(`https://bank2.daolog.net/download-file`, {
        params: { filePath },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filePath.split('/').pop());
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Помилка завантаження файлу');
    }
  };

  const toggleBankFilter = (bankType) => {
    setSelectedBanks(prev => 
      prev.includes(bankType)
        ? prev.filter(b => b !== bankType)
        : [...prev, bankType]
    );
  };

  const filteredFiles = conversionFiles.filter(file => {
    const bankTypeFilter = selectedBanks.length === 0 || selectedBanks.includes(file.bank_type.toLowerCase());
    const testFilter = !hideTestConversions || (file.username !== 'fibikus999' && file.username !== 'username');
    const usernameFilter = !searchUsername || file.username.toLowerCase().includes(searchUsername.toLowerCase());
    return bankTypeFilter && testFilter && usernameFilter;
  });

  const getBankStats = () => {
    const stats = {};
    conversionFiles
      .filter(file => file.username !== 'fibikus999' && file.username !== 'username')
      .forEach(file => {
        const bankType = file.bank_type.toLowerCase();
        stats[bankType] = (stats[bankType] || 0) + 1;
      });
    return stats;
  };

  const bankStats = getBankStats();

  const chartData = {
    labels: Object.keys(bankStats).map(bank => bank.toUpperCase()),
    datasets: [
      {
        data: Object.values(bankStats),
        backgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
          '#9966FF', '#FF9F40', '#FF6384', '#36A2EB',
          '#FFCE56', '#4BC0C0'
        ],
      },
    ],
  };

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '120px auto 0',
      padding: '0 20px'
    },
    header: {
      color: '#333',
      borderBottom: '2px solid #333',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    filterContainer: {
      marginBottom: '20px',
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
    },
    bankFilter: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginTop: '10px'
    },
    bankBadge: {
      cursor: 'pointer',
      padding: '8px 15px',
      margin: '5px',
      borderRadius: '20px',
    },
    selectedBankBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      margin: '5px',
      padding: '5px 10px',
    },
    card: {
      marginBottom: '20px',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    cardItem: {
      marginBottom: '10px',
      fontSize: '16px'
    },
    downloadButton: {
      marginTop: '10px'
    },
    filterButton: {
      marginLeft: '10px'
    },
    testFilter: {
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    searchInput: {
      marginTop: '10px',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ddd',
      width: '100%'
    },
    statsContainer: {
      marginTop: '20px',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
    },
    chartContainer: {
      maxWidth: '500px',
      margin: '20px auto',
    },
    tabButton: {
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      marginRight: '10px',
      transition: 'all 0.3s ease',
    },
    activeTabButton: {
      backgroundColor: '#966e95',
      color: '#383440',
    },
    inactiveTabButton: {
      backgroundColor: '#F8E0F7',
      color: '#666',
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h1 style={styles.header}>
          {activeTab === 'files' ? 'Оригінальні файли виписок' : 'Аналіз банківських виписок'}
        </h1>
        <div>
          <button 
            onClick={() => setActiveTab('files')}
            style={{ 
              ...styles.tabButton,
              ...(activeTab === 'files' ? styles.activeTabButton : styles.inactiveTabButton)
            }}
          >
            Оригінальні файли виписок
          </button>
          <button 
            onClick={() => setActiveTab('analysis')}
            style={{
              ...styles.tabButton,
              ...(activeTab === 'analysis' ? styles.activeTabButton : styles.inactiveTabButton)
            }}
          >
            Аналіз банківських виписок
          </button>
        </div>
      </div>

      {activeTab === 'files' && (
        <>
           <button 
            variant={showFilter ? "secondary" : "primary"}
            onClick={() => setShowFilter(!showFilter)}
            style={{
              ...styles.filterButton,
              backgroundColor: '#778899'
            }}
          >
            <FaFilter />
          </button>

          {showFilter && (
            <div style={styles.filterContainer}>
              <h5>Фільтр за типом банку:</h5>
              <div style={styles.bankFilter}>
                {bankTypes.map(bank => (
                  <Badge
                    key={bank}
                    bg={selectedBanks.includes(bank) ? "primary" : "secondary"}
                    style={styles.bankBadge}
                    onClick={() => toggleBankFilter(bank)}
                  >
                    {bank.toUpperCase()}
                    {selectedBanks.includes(bank) && " ✕"}
                  </Badge>
                ))}
              </div>
              <div style={styles.testFilter}>
                <input
                  type="checkbox"
                  id="hideTestConversions"
                  checked={hideTestConversions}
                  onChange={(e) => setHideTestConversions(e.target.checked)}
                />
                <label htmlFor="hideTestConversions">Не показувати тестові конвертації</label>
              </div>
              <input
                type="text"
                placeholder="Пошук за користувачем..."
                value={searchUsername}
                onChange={(e) => setSearchUsername(e.target.value)}
                style={styles.searchInput}
              />
            </div>
          )}
          
          <Container>
            {filteredFiles.map((record, index) => (
              <Card key={index} style={styles.card}>
                <div style={styles.cardItem}>
                  <strong>Номер конвертації:</strong> {record.id}
                </div>
                <div style={styles.cardItem}>
                  <strong>Користувач:</strong> {record.username}
                </div>
                <div style={styles.cardItem}>
                  <strong>Дата конвертації:</strong> {new Date(record.conversion_date).toLocaleString()}
                </div>
                <div style={styles.cardItem}>
                  <strong>Тип банку:</strong> {record.bank_type}
                </div>
                <div style={styles.cardItem}>
                  <strong>Шлях до файлу:</strong> {record.path}
                  <Button 
                    variant="primary"
                    style={styles.downloadButton}
                    onClick={() => handleDownload(record.path)}
                  >
                    Завантажити
                  </Button>
                </div>
              </Card>
            ))}
          </Container>
        </>
      )}

      {activeTab === 'analysis' && (
        <>
          <div style={styles.statsContainer}>
            <h4>Кількість записів по банках:</h4>
            {Object.entries(bankStats).map(([bank, count]) => (
              <div key={bank} style={styles.cardItem}>
                <strong>{bank.toUpperCase()}:</strong> {count} записів
              </div>
            ))}
          </div>
          
          <div style={styles.chartContainer}>
            <h4>Розподіл записів по банках:</h4>
            <Pie data={chartData} />
          </div>
        </>
      )}
    </div>
  );
};

export default ConversionFilesHistory;